<template>
    <div>
        <van-search
                placeholder="请输入小区名或地址"
                v-model="keywords"
                shape="round"
                show-action
                background="#3485FB"
                @search="onSearch('query')"
                @clear="onSearch('query')"
        >
            <div slot="action" @click="goMaps">
                <van-icon name="location" color="#ffffff"/>
            </div>
        </van-search>
        <van-notice-bar :key="noticeBar" v-for="noticeBar in this.noticeBars"
                :text="noticeBar"
                left-icon="volume-o"
        />
        <van-dropdown-menu>
            <van-dropdown-item v-model="division" :options="divisionOption" @change="onSearch('query')"/>
            <!--<van-dropdown-item v-model="avgPrice" :options="priceOption" @change="onSearch()"/>-->
            <van-dropdown-item v-model="houseHold" :options="apartmentOption" @change="onSearch('query')"/>
            <van-dropdown-item v-model="order" :options="orderOption" @change="onSearch('query')"/>
        </van-dropdown-menu>
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多数据了"
                    :error.sync="error"
                    :immediate-check="false"
                    error-text="请求失败，点击重新加载"
                    @load="onLoad"
            >
                <van-card v-for="item in regions" :key="item.regionId"
                          :title="item.regionName"
                          :thumb="thumb(item.logoPath)"
                          :thumb-link="item.viewPath"
                          @click="goRegion(item.regionId, item.regionName)"
                >
                    <div slot="desc">
                        <div class="van-card__desc van-ellipsis">
                            {{item.address}}
                        </div>
                        <!--<div>
                            备案均价：<label style="color: red">{{item.avgPrice == 0 ? '&#45;&#45;' : item.avgPrice}}元/㎡</label>
                        </div>-->
                        <div style="line-height: 20px">
                            预售许可日期:
                            <span class="van-card__desc van-ellipsis">
                            {{item.preSaleDate}}
                        </span>
                        </div>
                    </div>
                </van-card>
            </van-list>
        </van-pull-refresh>
        <!--<van-pagination
			v-model="currentPage"
			:page-count="pageCount"
			mode="simple"
			@change="onSearch('page')"
		/>-->
        <van-dialog v-model="isShow" :title="gzsData.title" :show-confirm-button="false" v-if="gzsData">

            <div :style="{'height':height/1.5+'px'}" class="dialog-content" v-html="gzsData.content"></div>
            <div class="botton-bottom" v-if="seconds===0">
                <van-button type="primary" disabled>我知道了</van-button>
            </div>
            <div class="botton-bottom" @click="toAgree(gzsData.isAllowClose==='N'&&seconds!==null)" v-else>
                <van-button type="primary" :disabled="gzsData.isAllowClose==='N'&&seconds!==null">我知道了  {{seconds}}</van-button>
            </div>
        </van-dialog>
    </div>
</template>

<script>
    import {Toast, NoticeBar} from 'vant'
    import {fetchRegions, fetchNoticeBars} from '@/api/houseResource/region'
    import {queryNoticeInfo,confirmRead } from "@/api/wx";

    export default {
        name: 'Home',
        components: {
            VanNoticeBar: NoticeBar
        },
        data() {
            return {
                keywords: '',
                division: '',
                avgPrice: '',
                houseHold: '',
                order: '',
                isShow:false,
                height:500,
                internal: null,
                seconds:0,
                gzsData:{},
                noticeBars: [],
                divisionOption: [
                  {value: '',      text: '不限'},
                  {value:'150402', text:'红山区'},
                  {value:'150404', text:'松山区'},
                  {value:'150403', text:'元宝山区'},
                  {value:'150421', text:'阿鲁科尔沁旗'},
                  {value:'150422', text:'巴林左旗'},
                  {value:'150423', text:'巴林右旗'},
                  {value:'150424', text:'林西县'},
                  {value:'150425', text:'克什克腾旗'},
                  {value:'150426', text:'翁牛特旗'},
                  {value:'150428', text:'喀喇沁旗'},
                  {value:'150429', text:'宁城县'},
                  {value:'150430', text:'敖汉旗'}
                ],
                priceOption: [
                    {
                        text: '不限',
                        value: ''
                    },
                    {
                        text: '7千以下',
                        value: ' < 7000 '
                    },
                    {
                        text: '7~8千元/㎡',
                        value: 'between 7000 and 8000'
                    },
                    {
                        text: '8~9千元/㎡',
                        value: 'between 8000 and 9000'
                    },
                    {
                        text: '9~10千元/㎡',
                        value: 'between 9000 and 10000'
                    },
                    {
                        text: '1万元/㎡以上',
                        value: ' > 10000'
                    }
                ],
                apartmentOption: [
                    {
                        text: '不限',
                        value: ''
                    },
                    {
                        text: '一室',
                        value: '一室'
                    },
                    {
                        text: '二室',
                        value: '二室'
                    },
                    {
                        text: '三室',
                        value: '三室'
                    },
                    {
                        text: '四室',
                        value: '四室'
                    },
                    {
                        text: '五室',
                        value: '五室'
                    },
                    {
                        text: '其他',
                        value: '其他'
                    }
                ],
                orderOption: [
                    {
                        text: '默认排序',
                        value: ''
                    },
                    /*{
                        text: '价格由高到低',
                        value: 'avgPrice desc '
                    },
                    {
                        text: '价格由低到高',
                        value: 'avgPrice asc'
                    },*/
                    {
                        text: '预售时间倒序',
                        value: 'preSalesDate desc'
                    },
                    {
                        text: '预售时间升序',
                        value: 'preSalesDate asc'
                    }
                ],
                //分页
                currentPage: 1,
                pageCount: 1,
                pageSize: 10,
                //下拉刷新
                isLoading: false,
                //滑动底部加载状态
                loading: false,
                //数据是否全部加载完毕
                finished: false,
                error: false,
                regions: [],
                isFlag:""
            }
        },
        destroyed() {
            clearInterval(this.internal);
            this.internal = null
        },
        mounted() {
            this.showLoading();
            this.height = document.documentElement.clientHeight
            console.log('this.height',this.height)
            queryNoticeInfo().then(response => {
                if(response.data&&response.data.length!==0){
                    this.gzsData = response.data[0]
                    console.log('this.isShow',this.isShow)
                    if(this.gzsData){
                        this.djs(this.gzsData)
                    }
                    //console.log("localStorage-isFirst"+localStorage.getItem("isFirst"))
                  if (this.$route.query.isFirst =='Y'){
                    this.isShow = true
                   // localStorage.setItem("isFirst",'Y');
                  }
                }else{
                    this.isShow = false
                }
                console.log('response',response)
            })
            let param = {
                pageNo: this.currentPage,
                pageSize: this.pageSize
            };
            fetchRegions(param).then(res => {
                this.regions = res.data.list;
                this.pageCount = res.data.page.totalPage;
                // 数据全部加载完成
                if (this.currentPage == this.pageCount || this.pageCount == 0) {
                    this.finished = true;
                }
                Toast.clear();
            });
            fetchNoticeBars().then(res => {
                this.noticeBars = res.data;
            })
        },
        methods: {
            djs(gzsData){
                let second = gzsData.displayTime;
                const timer = setInterval(() => {
                    second--;
                    if (second) {
                        this.seconds = second
                        console.log(
                            'second',second
                        )
                    } else {
                        this.seconds = null
                        clearInterval(timer);
                        this.$toast.clear();
                    }
                }, 1000);
            },
            toAgree(isclick){
                if(!isclick){
                    this.isShow = false
                    confirmRead(this.gzsData.sysGuid).then(response => {
                        console.log('response',response)
                    })
                }

            },
            thumb(logoPath) {
                return logoPath != null ? logoPath : require('@/assets/nothing.png');
            },
            //全屏加载提示
            showLoading() {
                Toast.loading({
                    // 持续展示 toast
                    duration: 0,
                    mask: true,
                    message: '加载中...'
                });
            },
            fetchData(value) {
                this.finished = true;
                //显示全屏加载
                this.showLoading();
                this.currentPage = value == 'page' ? this.currentPage : 1;
                let param = {
                    pageNo: this.currentPage,
                    pageSize: this.pageSize,
                    divisionCode: this.division,
                    avgPrice: this.avgPrice,
                    houseHold: this.houseHold,
                    order: this.order,
                    keywords: this.keywords
                };
                fetchRegions(param).then(res => {
                    this.regions = res.data.list;
                    this.pageCount = res.data.page.totalPage;
                    if (this.currentPage == this.pageCount || this.pageCount == 0) {
                        this.finished = true;
                    } else {
                        this.finished = false;
                    }
                    //取消全屏加载
                    Toast.clear();
                });
            },
            //搜索框搜索
            onSearch(value) {
                this.fetchData(value);
            },
            //瀑布流加载触发
            onLoad() {
                //滑动底部加载
                setTimeout(() => {
                    this.currentPage = this.currentPage + 1;
                    let param = {
                        pageNo: this.currentPage,
                        pageSize: this.pageSize,
                        divisionCode: this.division,
                        avgPrice: this.avgPrice,
                        houseHold: this.houseHold,
                        order: this.order,
                        keywords: this.keywords
                    };
                    fetchRegions(param).then(res => {
                        this.regions = this.regions.concat(res.data.list);
                        this.pageCount = res.data.page.totalPage;

                        // 加载状态结束
                        this.loading = false;

                        // 数据全部加载完成
                        if (this.currentPage == this.pageCount) {
                            this.finished = true;
                        }
                    }).catch(() => {
                        this.error = true;
                    });
                }, 500);
            },
            saveData() {
                this.$refs.form.validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    console.log('saving')
                })
            },
            //下拉刷新
            onRefresh() {
                this.currentPage = 1;
                let param = {
                    pageNo: this.currentPage,
                    pageSize: this.pageSize,
                    divisionCode: this.division,
                    avgPrice: this.avgPrice,
                    houseHold: this.houseHold,
                    order: this.order,
                    keywords: this.keywords
                };
                fetchRegions(param).then(res => {
                    this.regions = res.data.list;
                    this.pageCount = res.data.page.totalPage;
                    if (this.currentPage == this.pageCount || this.pageCount == 0) {
                        this.finished = true;
                    } else {
                        this.finished = false;
                    }
                    this.isLoading = false;
                });
                /*setTimeout(() => {
                    this.isLoading = false;
                }, 500);*/
            },
            //跳转查看地图
            goMaps: function () {
                this.$router.push("/houseResource/maps")
            },
            //列表点击
            goRegion(regionId, regionName) {
                this.$router.push({
                    path: '/houseResource/sales',
                    query: {
                        regionId: regionId,
                        regionName: encodeURIComponent(regionName),
                        from: '/houseResource'
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .botton-bottom{
        background: white;
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 10px 0;
        text-align: center;
    }
    .dialog-content{
        overflow: auto;
        padding: 0 20px 60px 20px;
        line-height: 30px
    }
    ::v-deep .van-dialog__header {
        font-weight: bold;
        font-size: 19px;
    }
    ::v-deep .van-button--normal {
        width: 60%;
    }
</style>
